import { eyePose } from './StudioFilters';

function anchored(ctx, landmarks, draw) {
  const pose = eyePose(landmarks);
  ctx.save();
  try {
    ctx.translate(pose.x, pose.y); ctx.rotate(pose.angle); ctx.scale(pose.distance, pose.distance);
    ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    const point = p => ({ x: ((p.x - pose.x) * Math.cos(pose.angle) + (p.y - pose.y) * Math.sin(pose.angle)) / pose.distance,
      y: (-(p.x - pose.x) * Math.sin(pose.angle) + (p.y - pose.y) * Math.cos(pose.angle)) / pose.distance });
    const nose = landmarks.getNose?.() || [];
    const mouth = landmarks.getMouth?.() || [];
    const tip = nose[3] ? point(nose[3]) : { x: 0, y: .48 };
    const lips = mouth.map(point);
    const mouthCenter = lips.length ? lips.reduce((a,p) => ({ x:a.x+p.x/lips.length, y:a.y+p.y/lips.length }),{x:0,y:0}) : {x:0,y:.9};
    const opening = lips.length > 19 ? Math.min(.6, Math.max(0, lips[18].y - lips[14].y)) : .08;
    draw({ tip, mouthCenter, opening });
  } finally { ctx.restore(); }
}

function oval(ctx,x,y,rx,ry,color,angle=0) {
  ctx.fillStyle=color; ctx.beginPath(); ctx.ellipse(x,y,rx,ry,angle,0,Math.PI*2); ctx.fill();
}
function star(ctx,x,y,r,color,points=5) {
  ctx.fillStyle=color; ctx.beginPath();
  for(let i=0;i<points*2;i++) {
    const angle=i*Math.PI/points-Math.PI/2, radius=i%2?r*.43:r;
    const px=x+Math.cos(angle)*radius, py=y+Math.sin(angle)*radius;
    if(i===0) ctx.moveTo(px,py); else ctx.lineTo(px,py);
  }
  ctx.closePath(); ctx.fill();
}
function ears(ctx, type, color, inner) {
  [-1,1].forEach(side=>{
    ctx.save(); ctx.translate(side*.85,-.65); ctx.rotate(side*.18);
    if(type==='floppy') {
      oval(ctx,side*.12,.05,.3,.64,color,-side*.15);
      oval(ctx,side*.1,.14,.16,.39,inner,-side*.15);
    } else if(type==='round') {
      oval(ctx,0,-.18,.36,.37,color); oval(ctx,0,-.18,.21,.22,inner);
    } else if(type==='long') {
      oval(ctx,0,-.43,.23,.72,color); oval(ctx,0,-.43,.11,.53,inner);
    } else {
      ctx.fillStyle=color; ctx.beginPath(); ctx.moveTo(-.34,.18); ctx.quadraticCurveTo(-.31,-.46,0,-.76);
      ctx.quadraticCurveTo(.28,-.4,.34,.18); ctx.closePath(); ctx.fill();
      ctx.fillStyle=inner; ctx.beginPath();ctx.moveTo(-.17,.03);ctx.lineTo(0,-.47);ctx.lineTo(.17,.03);ctx.closePath();ctx.fill();
    }
    ctx.restore();
  });
}
function animal(type,color,inner,{whiskers=false,tongue=false,spots=false,blush=false}={}) {
  return (ctx,frame,landmarks)=>anchored(ctx,landmarks,({tip,mouthCenter,opening})=>{
    ears(ctx,type,color,inner);
    if(spots) { oval(ctx,-.66,.23,.21,.25,'rgba(55,36,51,.72)',-.25); oval(ctx,.76,.52,.1,.13,'rgba(55,36,51,.6)'); }
    if(blush) [-1,1].forEach(side=>oval(ctx,side*.69,.48,.19,.1,'rgba(255,120,166,.38)'));
    oval(ctx,tip.x,tip.y,.16,.105,type==='long'?'#e887ae':'#382634');
    oval(ctx,tip.x-.035,tip.y-.04,.042,.018,'rgba(255,255,255,.6)');
    if(whiskers) {
      ctx.strokeStyle='rgba(255,243,230,.92)';ctx.lineWidth=.016;
      [-1,1].forEach(side=>[-1,0,1].forEach(row=>{
        ctx.beginPath();ctx.moveTo(tip.x+side*.28,tip.y+.07+row*.055);
        ctx.lineTo(tip.x+side*.78,tip.y+.06+row*.16);ctx.stroke();
      }));
    }
    if(tongue && opening>.1) {
      oval(ctx,mouthCenter.x,mouthCenter.y+.12,.12,.13+opening*.5,'#f48bac');
      ctx.strokeStyle='#c65980';ctx.lineWidth=.014;ctx.beginPath();ctx.moveTo(mouthCenter.x,mouthCenter.y+.07);ctx.lineTo(mouthCenter.x,mouthCenter.y+.18+opening*.35);ctx.stroke();
    }
  });
}
function fantasy(kind) {
  return (ctx,frame,landmarks)=>anchored(ctx,landmarks,()=>{
    if(kind==='crown') {
      const gold=ctx.createLinearGradient(0,-1.2,0,-.55);gold.addColorStop(0,'#fff2b1');gold.addColorStop(1,'#e7a52b');
      ctx.fillStyle=gold;ctx.beginPath();ctx.moveTo(-.85,-.55);ctx.lineTo(-.98,-1.12);ctx.lineTo(-.46,-.88);ctx.lineTo(0,-1.34);ctx.lineTo(.46,-.88);ctx.lineTo(.98,-1.12);ctx.lineTo(.85,-.55);ctx.closePath();ctx.fill();
      [-.53,0,.53].forEach((x,i)=>oval(ctx,x,-.72,.065,.09,['#e85b95','#79d9e8','#b99aff'][i]));
    } else if(kind==='halo') {
      ctx.strokeStyle='#ffeba4';ctx.lineWidth=.07;ctx.beginPath();ctx.ellipse(0,-1.05,.85,.17,-.08,0,Math.PI*2);ctx.stroke();
      star(ctx,-1,-.66,.12,'#fff3bc');star(ctx,.98,-.77,.09,'#fff3bc');
    } else if(kind==='unicorn') {
      ears(ctx,'point','#e4b9ff','#ff91c3');
      const horn=ctx.createLinearGradient(-.15,-1.8,.2,-.55);horn.addColorStop(0,'#fff1ac');horn.addColorStop(.5,'#eaaaff');horn.addColorStop(1,'#83e5f3');
      ctx.fillStyle=horn;ctx.beginPath();ctx.moveTo(-.19,-.6);ctx.lineTo(0,-1.7);ctx.lineTo(.19,-.6);ctx.closePath();ctx.fill();
      [-.6,0,.6].forEach((x,i)=>star(ctx,x,-.55,.15,['#ffb4da','#fff2b2','#a7edee'][i]));
    } else if(kind==='butterfly') {
      [-1,1].forEach(side=>{
        const x=side*.84,y=.3;
        oval(ctx,x-.09,y-.1,.14,.19,'#b59bff',-.4);oval(ctx,x+.09,y-.1,.14,.19,'#e89aff',.4);
        oval(ctx,x-.08,y+.11,.1,.12,'#76dbe7');oval(ctx,x+.08,y+.11,.1,.12,'#8ba5ff');oval(ctx,x,y,.022,.18,'#fff0ec');
      });
    } else if(kind==='flowers') {
      [-.8,-.4,0,.4,.8].forEach((x,i)=>{
        const y=-.62-Math.cos(x)*.2;
        for(let p=0;p<5;p++){const angle=p*Math.PI*2/5;oval(ctx,x+Math.cos(angle)*.105,y+Math.sin(angle)*.105,.09,.09,['#ff95ba','#ffd781','#a997f2','#88daca','#f5addf'][i]);}
        oval(ctx,x,y,.06,.06,'#fff0aa');
      });
    } else if(kind==='galaxy') {
      [-1,1].forEach(side=>{
        for(let i=0;i<6;i++)star(ctx,side*(.38+i*.11),.4+Math.sin(i*1.8)*.12,.035+(i%3)*.022,['#b9a1ff','#91e2ff','#fface7'][i%3],4);
      });
    } else if(kind==='confetti') {
      for(let i=0;i<18;i++) {
        const angle=i*Math.PI*2/18, x=Math.cos(angle)*1.13,y=Math.sin(angle)*.9-.25;
        ctx.save();ctx.translate(x,y);ctx.rotate(angle+.3);ctx.fillStyle=['#fa83b8','#ffdc77','#73dcd9','#b69bff'][i%4];ctx.fillRect(-.025,-.07,.05,.14);ctx.restore();
      }
    } else if(kind==='rainbow') {
      ['#ff809f','#ffba75','#ffdf7b','#86dcc2','#88b5f3','#c59aec'].forEach((color,i)=>{
        ctx.strokeStyle=color;ctx.lineWidth=.065;ctx.beginPath();ctx.arc(0,-.48,.78+i*.066,Math.PI,Math.PI*2);ctx.stroke();
      });
      [-1,1].forEach(side=>{oval(ctx,side*1.03,-.46,.21,.12,'#f4eefe');oval(ctx,side*.91,-.53,.13,.14,'#f4eefe');});
    }
  });
}
const entry=(id,name,icon,description,apply,category)=>({id,name,icon,description,apply,category});
function partyLook(kind) {
  return (ctx,frame,landmarks)=>anchored(ctx,landmarks,()=>{
    const colors=['#ff78c4','#83f6dd','#ffe399','#b6a0ff'];
    const time=performance.now()/1000;
    if(kind==='visor') {
      const gradient=ctx.createLinearGradient(-1,0,1,.2);colors.forEach((c,i)=>gradient.addColorStop(i/3,c));
      ctx.fillStyle=gradient;ctx.globalAlpha=.82;ctx.beginPath();ctx.roundRect(-1,-.22,2,.52,.18);ctx.fill();ctx.globalAlpha=1;
      ctx.strokeStyle='#fff';ctx.lineWidth=.025;ctx.beginPath();ctx.moveTo(-.8,-.1);ctx.lineTo(.6,-.1);ctx.stroke();
    } else if(kind==='hearts') {
      [-1,1].forEach(s=>{ctx.save();ctx.translate(s*.5,0);ctx.scale(.38,.38);ctx.fillStyle=s<0?'#ff78bd':'#b6a0ff';ctx.beginPath();ctx.moveTo(0,.7);ctx.bezierCurveTo(-1,-.1,-.8,-.9,0,-.35);ctx.bezierCurveTo(.8,-.9,1,-.1,0,.7);ctx.fill();ctx.restore();});
    } else if(kind==='lightning') {
      [-1,1].forEach(s=>{ctx.fillStyle=s<0?'#ffe399':'#83f6dd';ctx.beginPath();ctx.moveTo(s*.55,.25);ctx.lineTo(s*.85,.3);ctx.lineTo(s*.63,.59);ctx.lineTo(s*.85,.56);ctx.lineTo(s*.46,.98);ctx.lineTo(s*.58,.63);ctx.lineTo(s*.4,.65);ctx.closePath();ctx.fill();});
    } else if(kind==='jewels') {
      for(let i=0;i<9;i++){const x=(i-4)*.2;star(ctx,x,-.55-Math.cos(x)*.25,.06+(i===4?.06:0),colors[i%4],4);}
      [-1,1].forEach(s=>star(ctx,s*.82,.6,.12,'#d9faff',4));
    } else if(kind==='orbit') {
      ctx.strokeStyle='#b6a0ff';ctx.lineWidth=.035;ctx.beginPath();ctx.ellipse(0,-.55,1.2,.45,-.25,0,Math.PI*2);ctx.stroke();
      oval(ctx,Math.cos(time)*1.2,-.55+Math.sin(time)*.45,.13,.13,'#ffce94');
      star(ctx,-.55,-.65,.1,'#fff2bc');
    } else if(kind==='festival') {
      for(let i=0;i<20;i++){const a=i*Math.PI/10;star(ctx,Math.cos(a)*1.05,Math.sin(a)*.95-.2,.045+.02*Math.sin(time*2+i),colors[i%4],4);}
    }
  });
}
export const PLAYFUL_FILTERS = {
  prismVisor: entry('prismVisor',"משקף פריזמה",'◈',"משקף מבריק בשלל צבעים",partyLook('visor'),"צבע ואור"),
  heartEyes: entry('heartEyes',"עיני לב",'♥',"עדשות לב ורודות וסגולות",partyLook('hearts'),"פנטזיה"),
  lightning: entry('lightning',"חשמל",'ϟ',"ברקים בצבע מנטה וזהב על הלחיים",partyLook('lightning'),"צבע ואור"),
  faceJewels: entry('faceJewels',"תכשיטי זוהר",'💎',"אבני חן נוצצות על המצח והלחיים",partyLook('jewels'),"פנטזיה"),
  orbit: entry('orbit',"מסלול",'🪐',"כוכב לכת בצבעי פסטל שמקיף את הפנים",partyLook('orbit'),"פנטזיה"),
  festival: entry('festival',"אורות פסטיבל",'✺',"מסגרת קרנבל מנצנצת בעדינות",partyLook('festival'),"צבע ואור"),
  polarBear: entry('polarBear',"דוב קוטב",'🐻‍❄️',"אוזניים לבנות ופרטים בכחול עדין",animal('round','#ecf6ff','#a4d9ef',{blush:true}),"חיות"),
  mintBunny: entry('mintBunny',"ארנבון מנטה",'🐰',"אוזני מנטה עם נגיעות לילך",animal('long','#8de4d1','#b49aea',{whiskers:true}),"חיות"),
  cat: entry('cat',"חתול אפרסק",'🐱',"אוזני אפרסק, אף מבריק ושפם עדין",animal('point','#edbd8d','#f291b2',{whiskers:true,blush:true}),"חיות"),
  dog: entry('dog',"כלבלב",'🐶',"אוזניים בצבע קרמל · פתחו את הפה כדי להוציא לשון ורודה",animal('floppy','#ba8053','#e3af92',{tongue:true}),"חיות"),
  midnightCat: entry('midnightCat',"חתול קוסמי",'🐈‍⬛',"אוזניים סגולות, פרטים ורודים ושפם זוהר",animal('point','#64529f','#ed95d3',{whiskers:true,blush:true}),"חיות"),
  dalmatian: entry('dalmatian',"דלמטי",'🐾',"אוזני שמנת, כתמים שובבים ולשון מלאת הבעה",animal('floppy','#f4e9df','#695967',{tongue:true,spots:true}),"חיות"),
  bunny: entry('bunny',"ארנבון",'🐰',"אוזניים ארוכות ורכות, אף ורוד ושפם עדין",animal('long','#f4e6f0','#efa0c2',{whiskers:true,blush:true}),"חיות"),
  fox: entry('fox',"שועל",'🦊',"אוזני נחושת, קצוות בהירים ושפם לבן",animal('point','#e99049','#ffe0bd',{whiskers:true}),"חיות"),
  bear: entry('bear',"דוב דבש",'🐻',"אוזניים מעוגלות בצבע דבש ואף כפתור מבריק",animal('round','#bd8755','#e9b985',{blush:true}),"חיות"),
  panda: entry('panda',"פנדה",'🐼',"אוזניים שחורות עם מרכזי שמנת וכתמים על הלחיים",animal('round','#393445','#e6d9e1',{spots:true}),"חיות"),
  crown: entry('crown',"מלכותי",'👑',"כתר זהב עם אבני חן ורודות, תכולות ולילך",fantasy('crown'),"פנטזיה"),
  halo: entry('halo',"הילה זהובה",'😇',"הילה בצבע שמפניה וכוכבים קטנים וחמימים",fantasy('halo'),"פנטזיה"),
  unicorn: entry('unicorn',"חד־קרן",'🦄',"אוזני פסטל, קרן ססגונית ונזר כוכבים",fantasy('unicorn'),"פנטזיה"),
  butterfly: entry('butterfly',"פרפרים",'🦋',"פרפרי לילך וטורקיז על הלחיים",fantasy('butterfly'),"פנטזיה"),
  flowers: entry('flowers',"זר פרחים",'🌸',"זר פרחים קטנים בחמישה צבעים",fantasy('flowers'),"פנטזיה"),
  galaxy: entry('galaxy',"אבק כוכבים",'✨',"נמשי כוכבים בוורוד, לילך וכחול קרח",fantasy('galaxy'),"צבע ואור"),
  confetti: entry('confetti',"קונפטי",'🎉',"מסגרת קונפטי צבעונית שעוקבת אחר הפנים",fantasy('confetti'),"צבע ואור"),
  rainbowArc: entry('rainbowArc',"שמיים וקשת",'🌈',"קשת בצבעי פסטל עם עננים רכים",fantasy('rainbow'),"צבע ואור"),
};
